/**
 * The cookie whose value is Mirakl's `userId`: a UUID v4 minted at the edge by
 * mvt-assignment-ewkr, with a six-month lifetime. It is shared with multivariate testing, and a
 * separate advertising cookie was ruled out to save request-header space. If that changes, this is
 * the only line to update here.
 */
export const MIRAKL_USER_ID_COOKIE = 'mvt-uid';

/**
 * The cookie holding the customer's Cognito id token, written host-only on `www` by
 * `NothsTokenStorage` in `@noths/amplify` whenever a customer signs in or the token refreshes, and
 * removed at sign-out. It is the source of `userKey` (see `createMiraklUserKeyResolver`).
 */
export const MIRAKL_ID_TOKEN_COOKIE = 'nothsIdToken';
